module.exports = "/images/sea.png?99b347201098cd8ae846d7bfe92ec6ba";